import React, { Component } from "react";
//import { ResponsiveContainer } from 'recharts';
import { Panel } from "react-bootstrap";

export default class UsersChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
  }
  renderChart() {
	  return ("");
  }
  render() {
    return (
	  <center>
	    <Panel className="Chart">
          <Panel.Heading>Usuarios</Panel.Heading>
          <Panel.Body>
        	{this.renderChart()}
          </Panel.Body>
        </Panel> 
	  </center>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/summary/UsersChart.js